// Libs
import React, { useState, useEffect, useMemo } from 'react';

// Own Libs
import { Button, FormatText, GridView, Widget } from '@digital/ui';

//Api
import { getCrfFechamentoCurvaEconomica } from '@app/api/crf/crffechamento';
import { ICrfRelatorioCicloOrcamentario } from '@app/api/crf/crfRelatorioCicloOrcamentario';

//Files
import GraficoCurva from '@app/views/GraficoCurva';

//Utils

interface FechamentoCurvaEconomicaProps {
    fechamentoId: string;
}

const FechamentoCurvaEconomica = (props: FechamentoCurvaEconomicaProps) => {
    const { fechamentoId } = props;
    const [relatorio, setRelatorio] = useState<ICrfRelatorioCicloOrcamentario>();

    useEffect(() => {
        getCrfFechamentoCurvaEconomica(fechamentoId).then((data) => {
            setRelatorio(data);
        });
    }, [fechamentoId]);

    return (

        <GridView noform>
            <Widget
                title="RESULTADO"
                span={12}
                actions={[]}>

                {relatorio ? <GraficoCurva relatorio={relatorio} carregarTabela={true} /> : <> </>}
            </Widget>
        </GridView>

    );

}

export default FechamentoCurvaEconomica;